import React, { Fragment, useMemo, useState } from 'react'
import { Organization } from '../../../../helpers/models/Models';
import AppTable from '../../../../constants/AppTable';
import DialogBox from '../../../../constants/DialogBox';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import FileTextBox from '../../../../constants/FileTextBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { useFormik } from 'formik';
import AppURL from '../../../../constants/AppURL';
import { putDataToTheServer } from '../../../../helpers/api';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import { handleNepaliInputChange } from '../../../../helpers/handleChange';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
interface OrganizationListViewProps {
    data: {
        results: Organization[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    handleFormSuccess: () => void;
}
const OrgListView: React.FC<OrganizationListViewProps> = ({ data, loading, handleFormSuccess, error }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState<Organization | null>(null);
    const columns = useMemo(() => [
        { header: 'SN', accessor: 'sn', sortable: true },
        { header: 'Org. Name', accessor: 'org_name', sortable: true },
        { header: 'Org. Name(Nepali)', accessor: 'org_name_nep', sortable: true },
        { header: 'Address', accessor: 'org_add', sortable: false },
        { header: 'Address(Nepali)', accessor: 'org_add_nep', sortable: true },
        { header: 'Phone', accessor: 'org_phone', sortable: false },
        { header: 'Phone(Nepali)', accessor: 'org_phone_nep', sortable: false },
        { header: 'E-mail', accessor: 'email', sortable: false },
        { header: 'Pan No.', accessor: 'org_pan', sortable: false },
        { header: 'Pan No.(Nep)', accessor: 'org_pan_nep', sortable: false },
        { header: 'ESTD', accessor: 'org_estd', sortable: false },
        { header: 'Org. st. Date', accessor: 'org_stable_date', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },
    ], []);

    const modifiedData = useMemo(() => {
        if (!data) return [];
        return data.results.map((item: Organization) => ({
            sn: item.sn,
            org_name: item.org_name,
            org_name_nep: item.org_name_nep,
            org_add: item.org_add,
            org_add_nep: item.org_add_nep,
            org_phone: item.org_phone,
            org_phone_nep: item.org_phone_nep,
            org_estd: item.org_estd,
            email: item.email,
            org_pan: item.org_pan,
            org_stable_date: item.org_stable_date,
            org_pan_nep: item.org_pan_nep,
            org_reg: item.org_reg,
            org_reg_nep: item.org_reg_nep,
            logo: item?.logo || "",
            head_sign: item?.head_sign || "",
            org_estd_nep: item.org_estd_nep
        }));
    }, [data]);
    const handleEdit = (item: Organization) => {
        setCurrentItem(item);
        setDialogOpen(true);
    };
    const formik = useFormik({
        initialValues: {
            org_name: currentItem?.org_name || "",
            org_name_nep: currentItem?.org_name_nep || "",
            org_add: currentItem?.org_add || "",
            org_add_nep: currentItem?.org_add_nep || "",
            org_pan: currentItem?.org_pan || "",
            org_pan_nep: currentItem?.org_pan_nep || "",
            org_estd: currentItem?.org_estd || "",
            org_estd_nep: currentItem?.org_estd_nep || "",
            org_phone: currentItem?.org_phone || "",
            org_phone_nep: currentItem?.org_phone_nep || "",
            logo: "",
            email: currentItem?.email || "",
            org_reg: currentItem?.org_reg || "",
            org_reg_nep: currentItem?.org_reg_nep || "",
            head_sign: "",
            org_stable_date: currentItem?.org_stable_date || "",

        },
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("org_name", values.org_name);
            formData.append("org_name_nep", values.org_name_nep);
            formData.append("org_add", values.org_add);
            formData.append("org_add_nep", values.org_add_nep);
            formData.append("org_estd", values.org_estd);
            formData.append("org_estd_nep", values.org_estd_nep);
            formData.append("org_pan", values.org_pan);
            formData.append("org_pan_nep", values.org_pan_nep);
            formData.append("org_phone", values.org_phone);
            formData.append("org_stable_date", values.org_stable_date);
            formData.append("org_reg", values.org_reg);
            formData.append("org_reg_nep", values.org_reg_nep);
            formData.append("org_phone_nep", values.org_phone_nep);
            formData.append("email", values.email);
            if (values.logo) {
                formData.append("logo", values.logo);
            }
            if (values.head_sign) {
                formData.append("head_sign", values.head_sign);
            }
            try {
                await putDataToTheServer(AppURL.ApplicationURL + 'app/organizaion/structure/update/view/' + 1, formData).then((res) => {
                    if (res?.status === 200) {
                        handleFormSuccess();
                        setDialogOpen(false);
                        ToastSuccess({ message: res?.message });
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message?.tole_name });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onEdit={handleEdit}
            />
            {dialogOpen && currentItem && (
                <DialogBox open={dialogOpen} headerName='Organization Details Edit Update' close={() => setDialogOpen(false)}>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columnSpacing={3} rowSpacing={0.8}>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='org_name'
                                    label='Org. Name'
                                    handleChange={formik.handleChange}
                                    value={formik.values.org_name}
                                    error={formik.errors.org_name}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.org_name}
                                    required={true}
                                    placeholder='Enter Org. Name'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <NepaliInputBox
                                    label='Org. Name(Nepali)'
                                    name='org_name_nep'
                                    value={formik.values.org_name_nep}
                                    handleChange={(e) => handleNepaliInputChange(e, { setFieldValue: formik.setFieldValue, name: 'org_name_nep' })}
                                    required={true}
                                    handleBlur={formik.handleBlur}
                                    error={typeof formik.errors.org_name_nep === 'string' ? formik.errors.org_name_nep : undefined}
                                    placeholder='Enter Org. nepali name'
                                    touched={formik.touched.org_name_nep}
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='org_add'
                                    label='Address'
                                    handleChange={formik.handleChange}
                                    value={formik.values.org_add}
                                    error={formik.errors.org_add}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.org_add}
                                    required={false}
                                    placeholder='Enter address'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <NepaliInputBox
                                    label='Org. Address(Nepali)'
                                    name='org_add_nep'
                                    value={formik.values.org_add_nep}
                                    handleChange={(e) => handleNepaliInputChange(e, { setFieldValue: formik.setFieldValue, name: 'org_add_nep' })}
                                    required={true}
                                    handleBlur={formik.handleBlur}
                                    error={typeof formik.errors.org_add_nep === 'string' ? formik.errors.org_add_nep : undefined}
                                    placeholder='Enter Org. Address'
                                    touched={formik.touched.org_add_nep}
                                />
                            </Grid>


                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='org_phone'
                                    label='Phone No.'
                                    handleChange={formik.handleChange}
                                    value={formik.values.org_phone}
                                    error={formik.errors.org_phone}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.org_phone}
                                    required={false}
                                    placeholder='Enter Phone No.'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <NepaliInputBox
                                    label='Org. Phone No.(Nepali)'
                                    name='org_phone_nep'
                                    value={formik.values.org_phone_nep}
                                    handleChange={(e) => handleNepaliInputChange(e, { setFieldValue: formik.setFieldValue, name: 'org_phone_nep' })}
                                    required={true}
                                    handleBlur={formik.handleBlur}
                                    error={typeof formik.errors.org_phone_nep === 'string' ? formik.errors.org_phone_nep : undefined}
                                    placeholder='Enter Org. Phone(Nepali)'
                                    touched={formik.touched.org_phone_nep}
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='org_reg'
                                    label='Org Registration'
                                    handleChange={formik.handleChange}
                                    value={formik.values.org_reg}
                                    error={formik.errors.org_reg}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.org_reg}
                                    required={false}
                                    placeholder='Enter Org Reg.'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='org_stable_date'
                                    label='Org St. Date'
                                    handleChange={formik.handleChange}
                                    value={formik.values.org_stable_date}
                                    error={formik.errors.org_stable_date}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.org_stable_date}
                                    required={false}
                                    placeholder='Enter St. Date.'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <NepaliInputBox
                                    label='Org. Registration No.(Nepali)'
                                    name='org_reg_nep'
                                    value={formik.values.org_reg_nep}
                                    handleChange={(e) => handleNepaliInputChange(e, { setFieldValue: formik.setFieldValue, name: 'org_reg_nep' })}
                                    required={true}
                                    handleBlur={formik.handleBlur}
                                    error={typeof formik.errors.org_reg_nep === 'string' ? formik.errors.org_reg_nep : undefined}
                                    placeholder='Enter Org. Registration(Nepali)'
                                    touched={formik.touched.org_reg_nep}
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='email'
                                    label='E-mail'
                                    handleChange={formik.handleChange}
                                    value={formik.values.email}
                                    error={formik.errors.email}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.email}
                                    required={false}
                                    placeholder='Enter E-mail'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='org_pan'
                                    label='Pan No.'
                                    handleChange={formik.handleChange}
                                    value={formik.values.org_pan}
                                    error={formik.errors.org_pan}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.org_pan}
                                    required={false}
                                    placeholder='Enter Pan No.'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <NepaliInputBox
                                    label='Org. Pan(Nepali)'
                                    name='org_pan_nep'
                                    value={formik.values.org_pan_nep}
                                    handleChange={(e) => handleNepaliInputChange(e, { setFieldValue: formik.setFieldValue, name: 'org_pan_nep' })}
                                    required={true}
                                    handleBlur={formik.handleBlur}
                                    error={typeof formik.errors.org_pan_nep === 'string' ? formik.errors.org_pan_nep : undefined}
                                    placeholder='Enter Org. Pan No.'
                                    touched={formik.touched.org_pan_nep}
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='org_estd'
                                    label='Org. ESTD'
                                    handleChange={formik.handleChange}
                                    value={formik.values.org_estd}
                                    error={formik.errors.org_estd}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.org_estd}
                                    required={false}
                                    placeholder='Enter Org. ESTD'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <NepaliInputBox
                                    label='Org. ESTD(Nepali)'
                                    name='org_estd_nep'
                                    value={formik.values.org_estd_nep}
                                    handleChange={(e) => handleNepaliInputChange(e, { setFieldValue: formik.setFieldValue, name: 'org_estd_nep' })}
                                    required={true}
                                    handleBlur={formik.handleBlur}
                                    error={typeof formik.errors.org_estd_nep === 'string' ? formik.errors.org_estd_nep : undefined}
                                    placeholder='Enter Org. ESTD'
                                    touched={formik.touched.org_estd_nep}
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <FileTextBox
                                    type='file'
                                    name='logo'
                                    label='Logo'
                                    handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        const file = e.target.files?.[0];
                                        if (file) {
                                            formik.setFieldValue("logo", file); // Handle the file change correctly
                                        }
                                    }}
                                    error={formik.errors.logo}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.logo}
                                    required={false}
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <FileTextBox
                                    type='file'
                                    name='head_sign'
                                    label='Head Sign'
                                    handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        const file = e.target.files?.[0];
                                        if (file) {
                                            formik.setFieldValue("head_sign", file); // Handle the file change correctly
                                        }
                                    }}
                                    error={formik.errors.head_sign}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.head_sign}
                                    required={false}
                                />
                            </Grid>
                            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                                <EndBaseLine top={18}>
                                    <Button btn_type='update' type='submit' el='button' />
                                </EndBaseLine>
                            </Grid>
                        </Grid>
                    </form>
                </DialogBox>
            )}
        </Fragment>
    )
}

export default OrgListView